import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { UserDetail } from "./components/UserDetail";
import { UsersBulkUpload } from "./components/UsersBulkUpload";
import { UsersContainer } from "./components/users.container";

function UserDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.users.detail);
  const navigate = useNavigate();
  return (
    <Suspense fallback={<PageLoading />}>
      <UserDetail userId={id} onBack={() => navigate("..")} />
    </Suspense>
  );
}

export function UsersRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<UsersContainer />} />
        <Route path="bulk-upload" element={<UsersBulkUpload />} />
        <Route path=":id" element={<UserDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
